

export const SUCCESS_TIMEOUT = 5000;
export const ERROR_TIMEOUT = 5000;